
<template>
  <div>
    <div v-if="pageType !== 'request'">
      <div v-for="item in customFieldsForPageType">
        <input-text v-model="userCustomFields[item.name]"
                    :fieldName=item.name
                    :fieldId=item.name
                    fieldType="text"
                    :label=item.label
                    @keypress="validateInput($event)"
                    @paste="validateInput($event)"
                    :required="false"
                    :disabled="false" />
      </div>
    </div>
    <div v-else>
      <div class="form-group row" v-for="item in customFieldsForPageType">
        <label class="col-md-4 control-label">{{ item.label }}
          <p class="offer-form-notice">
            {{ $t("models.offer.not_visible_by_candidate") }}
          </p>
        </label>
        <div class="col-md-8">
          <input-text v-model="userCustomFields[item.name]"
                    :fieldName=item.name
                    :fieldId=item.name
                    fieldType="text"
                    :required="false"
                    @keypress="validateInput($event)"
                    @paste="validateInput($event)"
                    :disabled="false" />
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
  import InputText from '@/components/users/form/InputText'
  
  export default {
    name: 'EntityCustomFields',
    components: { InputText },
    props: {
      customFields: { type: Object },
      pageType: { type: String }
    },
    data() {
      return {
        internalCustomFields: this.customFields.configurations.filter((field) => field.page_type === this.pageType),
        userCustomFields: this.customFields.user
      }
    },
    watch: {
      userCustomFields: {
        deep: true,
        handler: function(params) {
          // remove empty fields
          Object.keys(params).forEach(function(key) {
            if (params[key] === null || params[key] === "") {
              delete params[key];
            }
          });
          this.$emit("user-custom-fields", params);
        }
      }
    },
    computed: {
      customFieldsForPageType() {
        return this.internalCustomFields;
      },
      
    },
    methods:{
      validateInput(event, item) {
        item = this.getCustomFieldByName(event.srcElement.id);
        let rule = this.getRule(item);
        let input = '';
        switch(event.type) {
          case 'keypress':
            input = String.fromCharCode(event.keyCode);
            break;
          case 'paste':
            input = event.clipboardData.getData('text');
            break;
          default:
            break;
        }
        if(rule.test(input)) return true;
        event.preventDefault()
      },
      getCustomFieldByName(name) {
        return this.customFieldsForPageType.find((field) => field.name === name);
      },
      getRule(item) {
        let french_chars = /^[\é\è\ë\ê\à\â\ï\î\ù\û\ô\ö\?\,\;\/\:\"\ç\']+$/
        let symbols = /^[\s\!\@\#\$\%\^\&\*\)\(+\=\._-]+$/
        let rule = '';
        switch(item.value_type) {
          case 'text':
            rule = this.concatRegexPatterns([/^[A-Za-z]+$/, french_chars, symbols]);
            break;
          case 'text_number':
            rule = this.concatRegexPatterns([/^[A-Za-z0-9]+$/, french_chars, symbols]);
            break;
          case 'number':
            rule = this.concatRegexPatterns([/^[0-9]+$/, symbols]);
            break;
          default:
            break;
        }
        return rule;
      },
      concatRegexPatterns(patterns) {
        let regexSource = patterns.map((pattern) => pattern.source).join('|');
        return new RegExp(regexSource);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/form/EntityCustomFields.vue